export default {fields:{url:{}},spreads:{BaseStorableSummary:{}}}